import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyEditAudit = lazyWithRetry(() => import("./EditAudit"));

const EditAudit = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyEditAudit {...props} />;

export default EditAudit;
